import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Link } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';
import { modalActions } from '../../redux/root-action';
import { isMobileApp, getDomain} from '../../utils/api';
import { modals } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey900};
  padding-top: 32px;
  margin-bottom: 24px;
`;

class RetirementIncomeModal extends Component<any, any> {
  handleLearnMoreClick = () => {
    const { hideModal, showModal } = this.props;
    const element = document.getElementById('rix-assumptions-text-open');
    const mq = window.matchMedia('(max-width: 768px)');
    if (isMobileApp() || mq.matches) {
      showModal(modals.RIX_ASSUMPTIONS);
    } else {
      window.location.href = getDomain() + '/workplace/en/participant/home/methodology-and-assumptions.html';
    }
  };

  render(): JSX.Element {
    return (
      <React.Fragment>
        <div id={`calculate-rig`}>
          <ReactModalHeader modalTitle={'How we calculate your Retirement Income Goal'} showClose={true} />
        </div>
        <ReactModalContent>
          <StyledText id={`rig-text`}>
            Unless you’ve entered a Retirement Income Goal, we estimate the percentage of your current salary required
            to maintain your lifestyle in retirement. This amount is based on your spending needs. Higher withdrawal
            amounts may be necessary due to withholding requirements or the need to pay taxes.
            <br />
            <br />
            To calculate your income goal (shown in today’s dollars) we subtract certain estimated taxes (state, federal
            and employment taxes) and any regular contributions made to your account(s) from your projected salary at
            retirement. Then we estimate how long your savings will last if you live off your Retirement Income Goal.
            <br />
            <br />
            <Link
              linkLabel="Learn More"
              color={tokens.ColorBrandInteractiveBlue}
              hoverColor={tokens.ColorBrandInteractiveBlueHover}
              onClick={this.handleLearnMoreClick}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleLearnMoreClick)}
              id={`rig-learn-more`}
            />
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default connect(null, {
  hideModal: modalActions.hideModal,
  showModal: modalActions.showModal,
})(RetirementIncomeModal);
